import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../../constants/paths';
export const useCheckEmail = () => {
  const navigate = useNavigate();
  const checkEmail = (email) =>
    navigate(`${PATHS.RESET_PASSWORD}?email=${email}`);
  return { checkEmail };
};
